import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { XXSMALL_BREAKPOINT } from '../../../../style'

export const Container = styled.div`
  background: white;
  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.1);
  border-radius: 1.25rem;
  padding: 16px 20px 24px;
`
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.25rem;
`
export const ProjectTitle = styled.a`
  cursor: pointer;
  font-weight: 900;
  line-height: 1.625rem;
  font-size: 1rem;
  flex: 1;
  color: ${colors.black1};
  padding-right: 0.5rem;

  &:hover,
  &:focus {
    color: ${colors.black1};
  }
`
export const Date = styled.div<{ isProjectCompleted?: boolean }>`
  font-size: 0.875rem;
  line-height: 1.625rem;
  color: ${({ isProjectCompleted }) => (isProjectCompleted ? `#36C17E` : colors.black1)};
  text-align: right;
`
export const Amount = styled.div`
  border-bottom: 1px solid ${colors.radagast};
  margin-bottom: 1rem;
`
export const AmountFlex = styled.div<{ centered?: boolean }>`
  display: flex;
  justify-content: ${({ centered }) => (centered ? 'center' : 'space-between')};

  > div:last-of-type {
    text-align: ${({ centered }) => (centered ? 'center' : 'right')};
  }
`
export const Price = styled.div`
  color: ${colors.black1};
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 0.375rem;

  span {
    font-size: 0.875rem;
    font-weight: 400;
  }
`
export const SmallText = styled.div`
  font-size: 0.625rem;
  line-height: 0.75rem;
  color: ${colors.black1};
`
export const AmountBar = styled.div<{ progress?: number }>`
  background: ${colors.radagast};
  border-radius: 3.125rem;
  position: relative;
  width: 100%;
  height: 0.625rem;
  overflow: hidden;

  &::after {
    content: '';
    top: 0;
    bottom: 0;
    background: ${({ progress }) => (progress === 100 ? `#36C17E` : colors.adaptBlue)};
    position: absolute;
    width: ${({ progress }) => progress && progress}%;
    left: 0;
  }
`
export const AmountWrapper = styled.div`
  margin-bottom: 1.5rem;
`
export const Includes = styled.div`
  font-size: 0.625rem;
  line-height: 0.75rem;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 1rem;
  color: ${colors.black1};
  padding-top: 0.5rem;

  img {
    margin-left: 0.2rem;
    vertical-align: bottom;
  }
  strong {
    font-size: 0.75rem;
  }
`
export const ProjectsWrapper = styled.div`
  text-align: center;
`
export const ProjectsButtton = styled.div<{ isActive?: boolean }>`
  height: 2.75rem;
  background: ${colors.nebula};
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  border-radius: 22px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  position: relative;
  cursor: pointer;
  width: auto;
  padding: 0 2.5rem;
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: ${colors.dawn};
  }
  &::after {
    content: '';
    position: absolute;
    width: 0.6rem;
    height: 0.5rem;
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1631677747/-homepage-icons/arrow-down-white.svg)
      no-repeat;
    left: 1rem;
    top: 1.125rem;
    ${({ isActive }) => isActive && `transform: rotate(180deg);`};
  }
  &::before {
    content: '';
    position: absolute;
    width: 0.6rem;
    height: 0.5rem;
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1631677747/-homepage-icons/arrow-down-white.svg)
      no-repeat;
    right: 1rem;
    top: 1.125rem;
    ${({ isActive }) => isActive && `transform: rotate(180deg);`};
  }
`
export const ProjectsList = styled.div`
  border-bottom: 1px solid ${colors.radagast};
  margin-bottom: 1.5rem;
`
export const ProjectItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  cursor: pointer;

  img {
    margin-left: 0.875rem;
    vertical-align: text-top;
  }
`
export const Cost = styled.div`
  white-space: nowrap;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    span {
      font-size: 0.875rem;
    }
  }
`
export const ReactToolTipStyles = createGlobalStyle`
  .__react_component_tooltip {
    && {
      background: rgba(32, 32, 32, 0.8);
      backdrop-filter: blur(12px);
      border-radius: 8px;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      padding: 8px 12px;

      &::after {
        display: none;
      }

      &.show {
        opacity: 1;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandWalletCard/BrandWalletCard.style.tsx